
import { namespace } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'
import * as contact from '~/store/modules/contact'
import * as sq from '~/store/modules/sq'
import * as cart from '~/store/modules/cart'

import ServiceQualification from '~/components/ServiceQualification.vue'
import Phone from '~/components/Icons/Phone.vue'
import Mail from '~/components/Icons/Mail.vue'
import AddressBar from '~/components/Plans/AddressBar.vue'
import Location from '~/components/Icons/LocationMarker.vue'
import PlanCardBusinessBundle from '~/components/Plans/PlanCardBusinessBundle.vue'
import ValidationError from '~/components/ValidationError.vue'
import BusinessContactForm from '~/components/ContactForm/Business.vue'
import { ContactForm } from '~/lib/contact/ContactForms'

const Contact = namespace(contact.name)
const SQ = namespace(sq.name)
const Cart = namespace(cart.name)


@Component({
  head() {
    return {
      title: `Business - ${this.brand.name}`,
      meta: [
        {
          hid: 'Business Plans',
          name: 'description',
          content: `Contact ${this.brand.name} on ${
            this.brand.phone
          } and speak with our friendly customer support. We're easy to reach in our Sydney based call centre and here to help.`
        }
      ]
    }
  },
  components: {
    ServiceQualification,
    Mail,
    Phone,
    AddressBar,
    Location,
    PlanCardBusinessBundle,
    ValidationError,
    BusinessContactForm
  },
  data() {
    return {
      siteId: process.env.siteId,
      brand: process.env.brand
    }
  }
})
export default class Business extends Vue {  
  @SQ.Getter
  isBusiness

  @SQ.Mutation
  setIsBusiness

  @Contact.Action
  create
  
  @Contact.Action
  validate
  
  @Cart.Mutation
  setCampaign
  
  @Cart.Mutation
  setCampaignSource

  error = false

  sending = false

  sent = false

  created() {
    if (!this.isBusiness) {
      this.setIsBusiness(true)
    }

    if (this.$route.query.campaign) { 
      this.setCampaign(this.$route.query.campaign)
    }
    if (this.$route.query.campaignsrc) { 
      this.setCampaignSource(this.$route.query.campaignsrc)
    }

    if (!['uni', 'hisp'].includes(process.env.siteId)) {
      this.$router.push({ path: '/' })
    }
  }

  async mounted() {
    try {
      await this.$recaptcha.init()
    } catch (e) {
      console.error(e);
    }
  }

  async handleSubmit(event: ContactForm) {
    try {
      this. sending = true
      const token = await this.$recaptcha.getResponse()
      await this.validate({...event, token})
      await this.$recaptcha.reset()
      await this.create(event)

      this.sending = false;
      this.sent = true;
    } catch(e: unknown) {
      this.error = true
    }
  }
}
